<template>
	<section
		class="hero page"
		v-if="pageData"
		:class="[
			{ 'no-bg': !checkIfBgOrVid() },
			'type-' + heroType,
			{ 'type-center': !headerImage }
		]"
		:data-hero-size="heroSize"
	>
		<div class="container">
			<div class="column-wrapper">
				<div class="column content">
					<h1
						v-if="pageData.headerTitle"
						class="hero-title"
						v-html="headerFilter(pageData.headerTitle)"
					></h1>
					<div v-if="pageData.headerSubtitle" class="hero-subtitle">
						{{ pageData.headerSubtitle }}
					</div>
					<div
						v-if="
							pageData.headerIntroText &&
							pageData.headerIntroText !== '<p><br></p>'
						"
						class="intro"
						v-html="pageData.headerIntroText"
					></div>
					<ul
						v-if="buttonData && buttonData.length > 0"
						class="button-wrapper"
					>
						<li
							v-for="(buttonItem, index) in buttonData"
							:key="index"
						>
							<router-link
								class="button"
								:class="{ alt: index === 1 }"
								:data-txt="buttonItem.label"
								:to="buttonItem.slug"
								>{{ buttonItem.label }}</router-link
							>
						</li>
					</ul>
				</div>
				<div class="column image">
					<img
						v-if="pageData.headerImageModel?.url"
						:src="pageData.headerImageModel?.url"
						alt="Hero Image"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
//Vue
import { defineComponent, ref, computed, watch, nextTick, onMounted } from "vue"

import { useGlobalStore } from "@/stores/global"

//Composables
import { useAuthenticationData } from "@/composables/useAuthenticationData"
import { useVideoAsset } from "@/composables/useVideoAsset"

import { fetchVideoContentDetails } from "@streampac.io/chef_sp_1"

export default defineComponent({
	props: ["pageData", "heroType", "heroSize"],
	emits: ["hero-ready"],
	setup(props, { emit }) {
		const globalStore = useGlobalStore()

		const isAuthenticated = computed(() => {
			return useAuthenticationData().data.value.isAuthenticated
		})

		const mediaDetailsObj = computed(() => {
			return useVideoAsset().data.value[shortData.value?.mediaId] || null
		})

		const shortData = ref(null)
		const headerImage = ref(null)
		const videoStarted = ref(false)
		const buttonData = ref([])
		const smallHeroDelay = ref(false)

		onMounted(() => {
			doOnInit()
		})

		watch(
			() => props.pageData,
			() => {
				doOnInit()
			}
		)

		//Init player when shortData is available
		watch(
			() => shortData.value,
			() => {
				initPlayer()

				//Trigger load asset
				useVideoAsset().getVideoAsset(shortData.value?.mediaId)
			}
		)

		function doOnInit() {
			if (
				props.pageData &&
				props.pageData.headerHighlightVideo !== "" &&
				props.pageData.headerHighlightVideo !== undefined
			) {
				fetchVideoContentDetails(
					isAuthenticated.value,
					props.pageData.headerHighlightVideo,
					"?flattenFields=true"
				).then((response) => {
					shortData.value = response
				})
			}

			let buttonArray = []

			if (
				props.pageData?.headerButtonUrl &&
				props.pageData?.headerButtonUrl !== ""
			) {
				let buttonLabel = "Read more"

				if (
					props.pageData?.headerButtonLabel &&
					props.pageData?.headerButtonLabel !== ""
				) {
					buttonLabel = props.pageData?.headerButtonLabel
				}

				const buttonItem = {
					slug: "/" + props.pageData.headerButtonUrl,
					label: buttonLabel
				}

				buttonArray.push(buttonItem)
			}

			if (
				props.pageData?.headerSecondButtonUrl &&
				props.pageData?.headerSecondButtonUrl !== ""
			) {
				let buttonLabel = "Read more"

				if (
					props.pageData?.headerSecondButtonLabel &&
					props.pageData?.headerSecondButtonLabel !== ""
				) {
					buttonLabel = props.pageData?.headerSecondButtonLabel
				}

				const buttonItem = {
					slug: "/" + props.pageData?.headerSecondButtonUrl,
					label: buttonLabel
				}

				buttonArray.push(buttonItem)
			}

			buttonData.value = buttonArray

			setTimeout(() => {
				smallHeroDelay.value = true
			}, 200)
		}

		function getVixyThumbnailUrl(val) {
			if (val && val !== "") {
				const newStr = val.replace(
					"/width/200",
					"/width/2560/height/800/"
				)

				return newStr
			}
		}

		function checkIfBgOrVid() {
			if (shortData.value?.mediaId && shortData.value?.mediaId !== "") {
				return true
			} else if (
				props.pageData?.headerImage &&
				props.pageData?.headerImage !== ""
			) {
				return true
			}

			emit("hero-ready", true)
			return false
		}

		function initPlayer() {
			if (
				shortData.value &&
				shortData.value.kalturaSession &&
				shortData.value.mediaId
			) {
				const { kWidget } = window

				// setTimeout(() => {
				nextTick(() => {
					kWidget.embed({
						targetId: "hero-" + shortData.value.mediaId,
						wid: globalStore.getVixyParams.partner,
						uiconf_id: globalStore.getVixyParams.uiconfid,
						flashvars: {
							ks: shortData.value.kalturaSession,
							loop: true,
							playlistAPI: {
								autoPlay: true
							},
							//Remove controls
							"controlBarContainer.plugin": false,
							"largePlayBtn.plugin": false,
							"loadingSpinner.plugin": false
						},
						entry_id: shortData.value.mediaId,
						readyCallback: () => {
							videoStarted.value = true
						}
					})
				})
				// }, 10);
			}
		}

		function headerFilter(val) {
			if (val && val !== "") {
				// First remove any existing HTML tags
				let cleanText = val.replace(/<[^>]*>?/g, "")

				// Parse BBCode tags and convert to HTML
				// [blue]...[/blue] -> <span class="blue">...</span>
				cleanText = cleanText.replace(
					/\[blue\](.*?)\[\/blue\]/g,
					'<span class="highlight-blue">$1</span>'
				)

				// You can add more BBCode patterns here:
				// [bold]...[/bold] -> <strong>...</strong>
				// cleanText = cleanText.replace(/\[bold\](.*?)\[\/bold\]/g, '<strong>$1</strong>')

				// [italic]...[/italic] -> <em>...</em>
				// cleanText = cleanText.replace(/\[italic\](.*?)\[\/italic\]/g, '<em>$1</em>')

				return cleanText
			}
		}

		return {
			isAuthenticated,
			mediaDetailsObj,
			shortData,
			headerImage,
			videoStarted,
			buttonData,
			smallHeroDelay,
			headerFilter,
			//functions
			getVixyThumbnailUrl,
			checkIfBgOrVid
		}
	}
})
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>

<style lang="scss">
//TMP HACK to see the entire width vid
.hero.page .kWidgetIframeContainer {
	transform: scale(1.4);
}

// @media only screen and (max-width: 1500px) {
//     .hero.page .kWidgetIframeContainer {
//         transform: scale(1.3);
//     }
// }

@media only screen and (max-width: 1120px) {
	.hero.page .kWidgetIframeContainer {
		transform: scale(1.5);
	}
}

@media only screen and (max-width: 980px) {
	.hero.page .kWidgetIframeContainer {
		transform: scale(1.7);
	}
}

// @media only screen and (max-width: 980px) {
//     .hero.page .kWidgetIframeContainer {
//         transform: none;
//     }
// }

@media only screen and (max-width: 880px) {
	.hero.page .kWidgetIframeContainer {
		transform: scale(2);
	}
}
</style>
